import { render, staticRenderFns } from "./Payslips.vue?vue&type=template&id=f27ea980"
import script from "./Payslips.vue?vue&type=script&lang=js"
export * from "./Payslips.vue?vue&type=script&lang=js"
import style0 from "./Payslips.vue?vue&type=style&index=0&id=f27ea980&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports